import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import type { Options } from 'src/pages/reporting/products/schema';
import { getProductsDetailSchema } from 'src/pages/reporting/products/schema';

export function useDraftedProductsDetailParams({ calculation }: Options) {
  return usePageParamsFromSchema(getProductsDetailSchema({ calculation }), {
    filters: { underlyingData: { label: 'Underlying Data' } },
  });
}

export type PageParams = ReturnType<typeof useDraftedProductsDetailParams>;
